module.exports = __webpack_public_path__ + "fa-brands-400.svg?d72293118cda50ec50c39957d9d836d0";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/fa-brands-400.svg
// module id = 48
// module chunks = 0